import { UpdateThemePack } from '@/types/theme-packs.types';
import { SaveColor } from '@/connection/theme-packs';
import { TemplatesReducerCreator } from '../types';

const saveThemePackReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async (themePack: UpdateThemePack) => {
      return SaveColor(themePack);
    },
    {
      fulfilled: (state, action) => {
        state.themePacks = state.themePacks?.map((theme) => {
          if (theme.color_pack === action.payload.color_pack) {
            return action.payload;
          }
          return theme;
        }) || [action.payload];
      },
      pending: (state, action) => {
        state.savingThemePack = action.meta?.arg?.color_pack || null;
      },
      rejected: (_, action) => {
        console.error(action.error);
      },
      settled: (state) => {
        state.savingThemePack = null;
      },
    }
  );
};

export default saveThemePackReducer;
